/* Global LP scripts — loaded on request.page_type == 'page' (see layout/theme.liquid).
   Add future site-wide LP behaviors here. */
(function () {
  if (window.__lpBaseInit) return;
  window.__lpBaseInit = true;

  /* ---------------------------------------------------------------------------
     Copy to clipboard — event delegation on document.
     Markup: <b class="lp-copy" data-copy="MUSCLE20" data-tip="Copy to clipboard">MUSCLE20</b>
       data-copy        text to copy (falls back to element textContent)
       data-tip         tooltip text (optional; no tooltip if absent)
       data-tip-copied  tooltip text after copy (optional; default "Copied!")
  --------------------------------------------------------------------------- */

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { fallbackCopy(text); });
    }
    fallbackCopy(text);
    return Promise.resolve();
  }

  function runCopy(el) {
    var text = el.getAttribute('data-copy') || el.textContent.trim();
    copyText(text).then(function () {
      if (el.hasAttribute('data-tip')) {
        if (!el.dataset.tipDefault) el.dataset.tipDefault = el.getAttribute('data-tip');
        el.setAttribute('data-tip', el.getAttribute('data-tip-copied') || 'Copied!');
        el.classList.add('is-copied');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el) runCopy(el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el) { e.preventDefault(); runCopy(el); }
  });

  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el && el.dataset.tipDefault) {
      el.setAttribute('data-tip', el.dataset.tipDefault);
      el.classList.remove('is-copied');
    }
  });

  document.addEventListener('focusout', function (e) {
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el && el.dataset.tipDefault) {
      el.setAttribute('data-tip', el.dataset.tipDefault);
      el.classList.remove('is-copied');
    }
  });

  /* a11y: make .lp-copy keyboard-focusable / announced as button */
  function enhance() {
    document.querySelectorAll('.lp-copy').forEach(function (el) {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
